import intro_0_poster from '../imgs/intro-0/poster.jpg';
import intro_1_bg from '../imgs/intro-1/bg.jpg';
import intro_2_phone from '../imgs/intro-2/phone.jpg';
import intro_2_body_main from '../imgs/intro-2/body_main.png';
import intro_2_body_trend from '../imgs/intro-2/body_trend.png';
import intro_2_bottom_score from '../imgs/intro-2/bottom_navi_score.png';
import intro_2_bottom_trend from '../imgs/intro-2/bottom_navi_trend.png';
import intro_2_phone_ko from '../imgs/intro-2/phone_ko.jpg';
import intro_2_body_main_ko from '../imgs/intro-2/body_main_ko.png';
import intro_2_body_trend_ko from '../imgs/intro-2/body_trend_ko.png';
import intro_2_bottom_score_ko from '../imgs/intro-2/bottom_navi_score_ko.png';
import intro_2_bottom_trend_ko from '../imgs/intro-2/bottom_navi_trend_ko.png';
import intro_3_01_poor_01 from '../imgs/intro-3/01_poor_01.png';
import intro_3_02_dust_poor from '../imgs/intro-3/02_dust_poor.png';
import intro_3_03_chemi_poor from '../imgs/intro-3/03_chemi_poor.png';
import intro_3_04_co2_fair from '../imgs/intro-3/04_co2_fair.png';
import intro_3_05_good_01 from '../imgs/intro-3/05_good_01.png';
import intro_3_06_dust_fair from '../imgs/intro-3/06_dust_fair.png';
import intro_3_07_humidity_fair from '../imgs/intro-3/07_humidity_fair.png';
import intro_3_08_fair_02 from '../imgs/intro-3/08_fair_02.png';
import intro_3_09_co2_poor from '../imgs/intro-3/09_co2_poor.png';
import intro_3_10_chemi_fair from '../imgs/intro-3/10_chemi_fair.png';
import intro_3_11_temp_poor from '../imgs/intro-3/11_temp_poor.png';
import intro_3_12_good_02 from '../imgs/intro-3/12_good_02.png';
import intro_3_13_temp_fair from '../imgs/intro-3/13_temp_fair.png';
import intro_3_14_humidity_poor from '../imgs/intro-3/14_humidity_poor_ko.png';
import intro_3_01_poor_01_ko from '../imgs/intro-3/01_poor_01_ko.png';
import intro_3_02_dust_poor_ko from '../imgs/intro-3/02_dust_poor_ko.png';
import intro_3_03_chemi_poor_ko from '../imgs/intro-3/03_chemi_poor_ko.png';
import intro_3_04_co2_fair_ko from '../imgs/intro-3/04_co2_fair_ko.png';
import intro_3_05_good_01_ko from '../imgs/intro-3/05_good_01_ko.png';
import intro_3_06_dust_fair_ko from '../imgs/intro-3/06_dust_fair_ko.png';
import intro_3_07_humidity_fair_ko from '../imgs/intro-3/07_humidity_fair_ko.png';
import intro_3_08_fair_02_ko from '../imgs/intro-3/08_fair_02_ko.png';
import intro_3_09_co2_poor_ko from '../imgs/intro-3/09_co2_poor_ko.png';
import intro_3_10_chemi_fair_ko from '../imgs/intro-3/10_chemi_fair_ko.png';
import intro_3_11_temp_poor_ko from '../imgs/intro-3/11_temp_poor_ko.png';
import intro_3_12_good_02_ko from '../imgs/intro-3/12_good_02_ko.png';
import intro_3_13_temp_fair_ko from '../imgs/intro-3/13_temp_fair_ko.png';
import intro_3_14_humidity_poor_ko from '../imgs/intro-3/14_humidity_poor_ko.png';
import intro_4_devices from '../imgs/intro-4/devices.png';
import intro_5_rev2 from '../imgs/intro-5/rev2.png';
import intro_5_element from '../imgs/intro-5/element.png';
import intro_6_glow_c from '../imgs/intro-6/glow_c.png';
import intro_7_mint from '../imgs/intro-7/mint.png';

const intro_0_movie_cdn =
  'https://s3-us-west-2.amazonaws.com/awair-static-assets/video/movie.mp4';
const intro_1_particle_temp_cdn =
  'https://s3-us-west-2.amazonaws.com/awair-static-assets/svg/temp-2x.svg';
const intro_1_particle_chemicals_cdn =
  'https://s3-us-west-2.amazonaws.com/awair-static-assets/svg/chemi-2x.svg';
const intro_1_particle_co2_cdn =
  'https://s3-us-west-2.amazonaws.com/awair-static-assets/svg/co2-2x.svg';
const intro_1_particle_dust_cdn =
  'https://s3-us-west-2.amazonaws.com/awair-static-assets/svg/dust-2x.svg';
const intro_1_particle_humidity_cdn =
  'https://s3-us-west-2.amazonaws.com/awair-static-assets/svg/humidity-2x.svg';

const IntroContents = {
  en: {
    movie: {
      header: {
        signUp: 'Sign up',
      },
      body: {
        header: `Know\n what’s in the air\n you breathe`,
        learn: 'LEARN',
      },
      next: 'monitor',
    },
    monitor: {
      header: {
        signUp: 'Sign up',
      },
      body: {
        header: 'Smart Air Monitor',
        description: `Awair identifies the 4-5 key factors that\n determine your air quality and gives you\n personalized recommendations to help\n you stay safe and healthy.`,
      },
      prev: 'movie',
      next: 'know',
    },
    know: {
      header: {
        signUp: 'Sign up',
      },
      body: {
        header: 'Know',
        description: `At a glance, you can see your air quality\n on the Awair display or in the Awair app.\n You can also track your improvements\n over time.`,
        phone: intro_2_phone,
        bodyMain: intro_2_body_main,
        bodyTrend: intro_2_body_trend,
        bottomScore: intro_2_bottom_score,
        bottomTrend: intro_2_bottom_trend,
      },
      prev: 'monitor',
      next: 'conquer',
    },
    conquer: {
      header: {
        signUp: 'Sign up',
      },
      body: {
        header: 'Conquer',
        description: `Awair gives you personalized\n recommendations that are proven to\n improve your air quality.`,
        tipCards: [
          intro_3_01_poor_01,
          intro_3_02_dust_poor,
          intro_3_03_chemi_poor,
          intro_3_04_co2_fair,
          intro_3_05_good_01,
          intro_3_06_dust_fair,
          intro_3_07_humidity_fair,
          intro_3_08_fair_02,
          intro_3_09_co2_poor,
          intro_3_10_chemi_fair,
          intro_3_11_temp_poor,
          intro_3_12_good_02,
          intro_3_13_temp_fair,
          intro_3_14_humidity_poor,
        ],
      },
      prev: 'know',
      next: 'breathe',
    },
    breathe: {
      header: {
        signUp: 'Sign up',
      },
      body: {
        header: 'Breathe Easy',
        description: `Awair also works with other smart\n devices to automatically keep your air\n clean and healthy.`,
      },
      prev: 'conquer',
      next: 'lineUpElement',
    },
    lineUpRev2: {
      header: {
        signUp: 'Sign up',
      },
      body: {
        description: 'PRODUCTS',
        shop: 'SHOP NOW',
      },
      prev: 'breathe',
      next: 'lineUpGlow',
    },
    lineUpElement: {
      header: {
        signUp: 'Sign up',
      },
      body: {
        description: 'PRODUCTS',
        shop: 'SHOP NOW',
      },
      prev: 'breathe',
      next: 'lineUpGlow',
    },
    lineUpGlow: {
      header: {
        signUp: 'Sign up',
      },
      body: {
        description: 'PRODUCTS',
        feature: 'Smart Plug + Ambient Light',
        shop: 'SHOP NOW',
        close: 'CLOSE',
      },
      prev: 'lineUpElement',
    },
  },
  ko: {
    movie: {
      header: {
        signUp: '가입하기',
      },
      body: {
        header: `Know\n what’s in the air\n you breathe`,
        learn: '자세히 보기',
      },
      next: 'monitor',
    },
    monitor: {
      header: {
        signUp: '가입하기',
      },
      body: {
        header: '스마트 공기질 측정기, 어웨어',
        description: `어웨어는 좋은 공기를 결정짓는\n 4-5가지 요소를 측정하고,\n 당신이 더욱 건강한 환경을 가꿀 수 있도록\n 맞춤형 팁을 제공합니다.`,
      },
      prev: 'movie',
      next: 'know',
    },
    know: {
      header: {
        signUp: '가입하기',
      },
      body: {
        header: '눈으로 보는 우리집 공기',
        description: `앱을 통해 어웨어가 측정한 실내 공기를\n 언제 어디서나 볼 수 있습니다.\n 또한 우리집 실내 공기가 변화하는\n 매순간을 그래프로 기록합니다.`,
        phone: intro_2_phone_ko,
        bodyMain: intro_2_body_main_ko,
        bodyTrend: intro_2_body_trend_ko,
        bottomScore: intro_2_bottom_score_ko,
        bottomTrend: intro_2_bottom_trend_ko,
      },
      prev: 'monitor',
      next: 'conquer',
    },
    conquer: {
      header: {
        signUp: '가입하기',
      },
      body: {
        header: '공기 전문가가 되세요',
        description: `실내 공기에 따라 맞춤형 팁과 알림을\n 제공합니다. 어웨어 팁을 따라하다보면\n 건강한 환경을 유지할 수 있습니다.`,
        tipCards: [
          intro_3_01_poor_01_ko,
          intro_3_02_dust_poor_ko,
          intro_3_03_chemi_poor_ko,
          intro_3_04_co2_fair_ko,
          intro_3_05_good_01_ko,
          intro_3_06_dust_fair_ko,
          intro_3_07_humidity_fair_ko,
          intro_3_08_fair_02_ko,
          intro_3_09_co2_poor_ko,
          intro_3_10_chemi_fair_ko,
          intro_3_11_temp_poor_ko,
          intro_3_12_good_02_ko,
          intro_3_13_temp_fair_ko,
          intro_3_14_humidity_poor_ko,
        ],
      },
      prev: 'know',
      next: 'breathe',
    },
    breathe: {
      header: {
        signUp: '가입하기',
      },
      body: {
        header: '다양한 기기들과 연동',
        description: `어웨어는 다른 스마트기기들과의 연동으로\n 당신이 더욱 건강한 환경에서 숨쉴 수\n 있도록 도와줍니다.`,
      },
      prev: 'conquer',
      next: 'lineUpRev2',
    },
    lineUpRev2: {
      header: {
        signUp: '가입하기',
      },
      body: {
        description: 'PRODUCTS',
        shop: '제품 보러가기',
      },
      prev: 'breathe',
      next: 'lineUpMint',
    },
    lineUpMint: {
      header: {
        signUp: '가입하기',
      },
      body: {
        description: 'PRODUCTS',
        shop: '제품 보러가기',
        close: '닫기',
      },
      prev: 'lineUpRev2',
    },
  },
  common: {
    movie: {
      background: {
        video: intro_0_movie_cdn,
        poster: intro_0_poster,
      },
      timeout: {
        page: { enter: 100, exit: 550 },
        header: { enter: 500, exit: 50 },
      },
    },
    monitor: {
      background: intro_1_bg,
      backgroundColor: '#acb4bb',
      timeout: {
        page: { enter: 100, exit: 550 },
        header: { enter: 500, exit: 50 },
        description: { enter: 650, exit: 200 },
        canvas: 900,
      },
      particles: [
        { x: -121.6, y: 93.6, cdn: intro_1_particle_temp_cdn },
        { x: -76, y: 132.8, cdn: intro_1_particle_chemicals_cdn },
        { x: 0, y: 100, cdn: intro_1_particle_co2_cdn },
        { x: 73.6, y: 141, cdn: intro_1_particle_dust_cdn },
        { x: 120.933333, y: 84.2, cdn: intro_1_particle_humidity_cdn },
      ],
    },
    know: {
      backgroundColor: '#bdcad8',
      timeout: {
        page: { enter: 50, exit: 550 },
        header: { enter: 500, exit: 50 },
        description: { enter: 650, exit: 200 },
      },
    },
    conquer: {
      backgroundColor: '#e6d2bc',
      timeout: {
        page: { enter: 50, exit: 550 },
        header: { enter: 500, exit: 50 },
        description: { enter: 650, exit: 200 },
        card: { enter: 750, exit: 50 },
      },
    },
    breathe: {
      background: intro_4_devices,
      backgroundColor: '#c2cad0',
      images: {
        devices: intro_4_devices,
      },
      timeout: {
        page: { enter: 50, exit: 550 },
        header: { enter: 500, exit: 50 },
        description: { enter: 650, exit: 200 },
      },
    },
    lineUpRev2: {
      product: intro_5_rev2,
      background:
        'linear-gradient(to top, #F1F3F4 0%, #F1F3F4 40%, #AEBAC4 40%, #93A1AF)',
      timeout: {
        page: { enter: 50, exit: 550 },
        header: { enter: 650, exit: 200 },
        description: { enter: 500, exit: 50 },
        canvas: 900,
      },
    },
    lineUpElement: {
      product: intro_5_element,
      background:
        'linear-gradient(to top, #F1F3F4 0%, #F1F3F4 40%, #AEBAC4 40%, #93A1AF)',
      timeout: {
        page: { enter: 50, exit: 550 },
        header: { enter: 650, exit: 200 },
        description: { enter: 500, exit: 50 },
        canvas: 900,
      },
    },
    lineUpGlow: {
      product: intro_6_glow_c,
      background:
        'linear-gradient(to top, #F1F3F4 0%, #F1F3F4 40%, #AEBAC4 40%, #93A1AF)',
      timeout: {
        page: { enter: 50, exit: 550 },
        header: { enter: 650, exit: 200 },
        description: { enter: 500, exit: 50 },
        canvas: 900,
      },
    },
    lineUpMint: {
      product: intro_7_mint,
      background:
        'linear-gradient(to top, #F1F3F4 0%, #F1F3F4 40%, #AEBAC4 40%, #93A1AF)',
      timeout: {
        page: { enter: 50, exit: 550 },
        header: { enter: 650, exit: 200 },
        description: { enter: 500, exit: 50 },
        canvas: 900,
      },
    },
  },
};

export default IntroContents;



// WEBPACK FOOTER //
// ./src/assets/contents/intro.js